import React, { useState, useEffect } from 'react';
import { useMediaQuery } from '@material-ui/core';
import Switch from '@material-ui/core/Switch';
import * as apiClient from "../common/apiClient";
import { makeStyles } from '@material-ui/core/styles';
import CountBlock from "./CountBlock";
import HolidayList from "./HolidayList";
import { Create, SimpleForm, TextInput, BooleanInput, DateInput, useNotify, NumberInput, required, ReferenceInput, AutocompleteInput, SelectInput } from 'react-admin';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import CustomCalendar from './customcalender/CustomCalendar';
import AssessmentIcon from '@material-ui/icons/Assessment';
import CasesList from './CasesList';
import exportFromJSON from 'export-from-json'
const useStyles = makeStyles({
    flexCenter: { display: 'flex', justifyContent: "center", alignContent: "center", flexWrap: "wrap" },
    flex: { display: 'flex' },
    flexColumn: { display: 'flex', flexDirection: 'column' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em', marginBottom: '2em' },
    locationPrompt: { 
        padding: "10px", 
        backgroundColor: "#ffcc00", 
        color: "#333", 
        borderRadius: "5px", 
        marginBottom: "10px",
        textAlign: "center" 
    },
    button: { 
        marginTop: '10px', 
        padding: '5px 10px', 
        backgroundColor: '#f4a261', 
        color: '#fff', 
        border: 'none', 
        cursor: 'pointer' 
    }
});
const Dashboard = (props) => {
    const [db, setdb] = useState([]);
    const [dbExport, setdbExport] = useState([]);
    console.log(props, "===dbExport===");
    const [fetchingAttedanceStatus, setFetchingAttedanceStatus] = useState(true);
    const [attType, setAttType] = useState("");
    const [workLocation, setWorkLocation] = useState("");
    const [attOnOff, setattOnOff] = useState(false);
    const notify = useNotify();
    const styles = useStyles({});
    const [holiday, setHoliday] = useState([]);
    var myDate = new Date();

    const [fromdate, setFromDate] = useState( new Date(myDate.setTime( myDate.getTime() - 365 * 86400000 )));
    const [todate, setToDate] = useState(new Date());
    const [insurerId, setInsurerId] = useState(0);
    const [tpaId, setTpaId] = useState(0);
    const [foId, setFOId] = useState(0);
    const [hospitalId, setHospitalId] = useState(0);   
    const [isLocationEnabled, setIsLocationEnabled] = useState<any>(null);
    const [showLocationPrompt, setShowLocationPrompt] = useState(false);
    const [latitude, setLatitude] = useState<number | null>(null);  // Store latitude
    const [longitude, setLongitude] = useState<number | null>(null);  // Store longitude
    const [dashboardkrasData, setDashboardkrasData] = useState<any>([]);  // Store longitude
    let permissions:any = {  };
    let propsObj = { ...props };
  if (propsObj.permissions) { 
    let resourcename = `/dashboard`;
    let myPermissions = propsObj.permissions.filter(item => item.NavigateUrl.toLowerCase().trim() == resourcename);
    if (myPermissions.length > 0) {
      permissions={...myPermissions[0]};
    }
    console.log(permissions, "===permissions===");
  }
    
    const loadDashboard = () => {
        let userid = localStorage.getItem("userId");
        setdb([]);
         
        
    
        apiClient.get_dashboard(userid).then(res => {
            setdb(res);
        }).catch(err => {
            console.log(err);
        });
    }
    const GetDashboardHoliday = () => {
        apiClient.GetDashboardHoliday().then(res => {
            //console.log(res);
            setHoliday(res);
        }).catch(err => {
            console.log(err);
        });
    }
    const GetDashboardkras = () => {
        apiClient.GetDashboardkras().then(res => {
            //console.log(res);
            setDashboardkrasData(res);
        }).catch(err => {
            console.log(err);
        });
    }
    
    const handleAttendance = (event) => {
        return
        if (!isLocationEnabled) {
            //notify("Please enable location to mark attendance", "warning");
           // setShowLocationPrompt(true); // Show prompt to enable location
            return;
        }
        if (workLocation === null || workLocation === "") {
            notify("Please Select Work location", "warning");
            return;
        }
        if (attType === "ATT_END" && window.confirm('Do you really want to end your working?')) {
            updateAttedance();
        }
        if (attType === "ATT_START" && window.confirm('Do you really want to Start your working?')) {
            updateAttedance();
        }
    }

    const updateAttedance = () => {
        setFetchingAttedanceStatus(true);
        let userid = localStorage.getItem("userId");
        let formBody = {
            userId: userid,
            attType: attType,
            location: workLocation,
            latitude: latitude,  // Add latitude
            longitude: longitude  // Add longitude
        }
        apiClient.updateAttendance(formBody).then(res => {
            notify(res[0].Msg)
            loadAttendance();
        }).catch(err => {
            console.log(err);
        });
    }
    function exportToCSV(data) {
        const fileName = 'download'
        const exportType = 'xls'
        exportFromJSON({ data, fileName, exportType })
    
      }
    const onExport = (OrdId,Key) => {

        let userid = localStorage.getItem("userId");
        setdbExport([]);
        let data={
            UserID:userid,
            FromDate:fromdate,
            ToDate:todate,
            Ord:OrdId,
            Type:'Detailed',
            RepTp:Key,
            FOID:foId,
            HospitalID:hospitalId,
            TPAId:tpaId,
            InsurerID:insurerId 
        };
        //new Date().setDate(new Date().getDate() -365)
    
        apiClient.get_dashboard_v1(data).then(res => {
            
            exportToCSV(res);
        }).catch(err => {
            console.log(err);
        });
        //alert(Key)
    }
    const loadAttendance = () => {
        setFetchingAttedanceStatus(true);
        let userid = localStorage.getItem("userId");
        apiClient.get_attendancestatus(userid).then(res => {

            setAttType(res[0].Msg);
            setWorkLocation(res[0].location)
            if (res[0].Msg === 'ATT_START') {
                setattOnOff(false)
            }
            if (res[0].Msg === 'ATT_END') {
                setattOnOff(true)
            }

            setFetchingAttedanceStatus(false);
        }).catch(err => {
            //alert(JSON.stringify(err))
            console.log(err);
        });
    }
    const checkLocationPermission = () => {
        return
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setIsLocationEnabled(true);  // Location is enabled
                    setLatitude(position.coords.latitude);  // Store latitude
                    setLongitude(position.coords.longitude);  // Store longitude
                    setShowLocationPrompt(false); // Hide prompt
                },
                (error) => {
                    setIsLocationEnabled(false);  // Location is not enabled
                    setShowLocationPrompt(true);  // Show prompt to enable location
                }
            );
        } else {
            setIsLocationEnabled(false); // Geolocation not supported
            setShowLocationPrompt(true); // Show prompt
        }
    }
    useEffect(() => {
        loadDashboard();
        loadAttendance();
        GetDashboardHoliday();
        GetDashboardkras();
    }, []);
    const recheckLocationPermission = () => {
        checkLocationPermission();  // Recheck the location permission
        notify("Rechecked location permission.");
    }
    useEffect(() => {
        checkLocationPermission();  // Check for location permission on component mount
         
    }, []);
    return (
        <SimpleForm toolbar={null}>
            <div style={{ width: "100%" }}>
            {<div className={styles.flexCenter}>
                        
                        {db && db.map((item: any, index: number) => {
                            return (
                                <div key={index}>
                                    <CountBlock title={item.Descriptions} value={item.TotalCount} icon={item.IconUrl} />
                                </div>
                            )
                        })}

                    </div>
                    }

            </div>
        </SimpleForm >
    );
}

export default Dashboard;
